import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../../constants/app-constants';
import { InteractorResponse } from '../../models/interactor-response';
import { AbstractServiceTypeService } from '../abstract/abstract-service-type-service';
import { ServiceTypeModel } from 'src/app/store/service-type/model';

const baseUrl = `/api/servicetypes`;

@Injectable()
export class ServiceTypeService extends AbstractServiceTypeService {
  private http = inject(HttpClient);

  getAll(): Observable<InteractorResponse<ServiceTypeModel[]>> {
    return this.http.get<InteractorResponse<ServiceTypeModel[]>>(`${baseUrl}`);
  }
}
